export default "__VITE_ASSET__DPXNiJ3J__"